import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
import { motion } from 'framer-motion';
import { Brain, Heart, Layout } from 'lucide-react';
export function SolutionMechanism() {
  return <>
      <Section dark className="text-center" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} data-id="element-194">
          <span className="text-[#d4af37] uppercase tracking-widest text-sm font-semibold mb-4 block" data-id="element-195">
            Por eso existe
          </span>
          <h2 className="text-4xl md:text-6xl font-serif text-white mb-8" data-id="element-196">
            ABUNDANCIA & DINERO
          </h2>

          <div className="max-w-3xl mx-auto bg-white/5 backdrop-blur-md p-8 rounded-xl border border-white/10 mb-12" data-id="element-197">
            <p className="text-xl text-[#f4e5c3] mb-4 font-serif" data-id="element-198">
              ABUNDANCIA & DINERO es para una mujer muy específica:
            </p>
            <p className="text-white/90 leading-relaxed" data-id="element-199">
              La que está cansada de sobrevivir. La que siente presión económica
              real. La que quiere prosperar sin culpa. La que cree en el
              desarrollo personal… pero exige resultados reales.
            </p>
          </div>

          <p className="text-2xl font-serif text-[#d4af37] mb-8" data-id="element-200">
            Aquí no te vendo fantasía. Te doy integración.
          </p>

          <CTAButton text="QUIERO ENTRAR AHORA" data-id="element-201" />
        </motion.div>
      </Section>

      <Section data-id="element-202">
        <div className="text-center mb-16" data-id="element-203">
          <h3 className="text-3xl font-serif text-[#0f4c3a] mb-4" data-id="element-204">
            El mecanismo único:
          </h3>
          <p className="text-xl text-[#d4af37] font-medium" data-id="element-205">
            Reprogramación + Alineación + Sistema Consciente
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-206">
          {[{
          icon: <Brain className="w-8 h-8 text-[#d4af37]" data-id="element-207" />,
          title: '1) Reprogramación',
          desc: "Desmontas creencias heredadas (culpa, miedo, merecimiento). Porque si tu identidad sigue en 'escasez'… tu vida vuelve a cero."
        }, {
          icon: <Heart className="w-8 h-8 text-[#d4af37]" data-id="element-208" />,
          title: '2) Alineación',
          desc: "No 'pensar bonito'. Es intención + emoción + acción. (Lo que piensas, lo que sientes y lo que haces por fin apuntan hacia el mismo lado.)"
        }, {
          icon: <Layout className="w-8 h-8 text-[#d4af37]" data-id="element-209" />,
          title: '3) Sistema Consciente',
          desc: "Un método práctico para sostener dinero en la vida real (incluye un 50/30/20 adaptado + hábitos). No para la mujer 'perfecta'. Para ti, con cansancio, con presión, con vida."
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.2
        }} className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-[#d4af37] hover:shadow-xl transition-shadow" data-id="element-210">
              <div className="bg-[#0f4c3a]/5 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-211">
                {item.icon}
              </div>
              <h4 className="text-xl font-serif text-[#0f4c3a] font-bold mb-4 text-center" data-id="element-212">
                {item.title}
              </h4>
              <p className="text-slate-600 text-center leading-relaxed" data-id="element-213">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </Section>

      {/* Metaphor 2: Thermostat */}
      <Section dark className="overflow-hidden" data-id="element-214">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-215">
          <div className="absolute right-0 top-0 w-96 h-96 bg-[#d4af37] rounded-full blur-[100px] translate-x-1/2 -translate-y-1/2" data-id="element-216"></div>
        </div>

        <div className="relative z-10 grid md:grid-cols-2 gap-12 items-center" data-id="element-217">
          <div data-id="element-218">
            <h3 className="text-3xl font-serif text-[#d4af37] mb-6" data-id="element-219">
              Metáfora 2: tu termostato interno
            </h3>
            <p className="text-lg text-white mb-6" data-id="element-220">
              Ganar más es como abrir la ventana. Pero si tu termostato está
              programado en "escasez", tu sistema vuelve al mismo punto.
            </p>
            <p className="text-2xl font-serif text-white mb-6" data-id="element-221">
              Vuelves a cero.
            </p>
            <p className="text-white/90" data-id="element-222">
              Porque el dinero puede entrar… pero si tu identidad no cambió… no
              se queda.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-md p-8 rounded-2xl border border-white/20" data-id="element-223">
            <div className="mb-6" data-id="element-224">
              <p className="text-[#d4af37] font-serif italic text-xl mb-2" data-id="element-225">
                "Pero yo no gano mucho…"
              </p>
              <p className="text-white font-bold text-lg" data-id="element-226">Perfecto.</p>
            </div>
            <p className="text-white/90 mb-6" data-id="element-227">
              Entonces esto es aún más necesario. Porque cuando el ingreso es
              ajustado, el sistema importa el doble.
            </p>
            <div className="bg-[#0f4c3a] p-4 rounded-lg border border-[#d4af37]/30" data-id="element-228">
              <p className="text-sm text-[#f4e5c3] mb-2" data-id="element-229">
                ABUNDANCIA & DINERO no empieza con "invierte y ya". Empieza
                donde de verdad se construye:
              </p>
              <p className="font-serif text-[#d4af37] text-lg text-center" data-id="element-230">
                claridad → control → identidad → hábito → estructura simple
              </p>
              <p className="text-sm text-[#f4e5c3] mt-2 text-center" data-id="element-231">
                Para que cuando llegue más dinero… no se vaya.
              </p>
            </div>
          </div>
        </div>
      </Section>
    </>;
}